(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PermissionController', PermissionController);

    PermissionController.$inject = ['$scope', '$state', 'Permission'];

    function PermissionController ($scope, $state, Permission) {
        var vm = this;

        vm.permissions = [];

        loadAll();

        function loadAll() {
            Permission.query(function(result) {
                vm.permissions = result;
                vm.searchQuery = null;
            });
        }
    }
})();
